// extracted by mini-css-extract-plugin
export default {"drawer":"SidePanel_drawer__KbwmH","sectionHeader":"SidePanel_sectionHeader__oY840","menuItem":"SidePanel_menuItem__QF5nd","shimmer":"SidePanel_shimmer__m+5kx"};